module.exports = ".RcTechLogo{\n    width:300px;\n    height: 300px;\n}"